/*
 * Created on Sun Aug 1 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import React, { Component } from 'react';
import Snap from './pages/snap'

class ErrorBoundary extends Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
      this.logErrorToService(error, errorInfo);
    }

    // A fake logging service.
    logErrorToService = console.log;
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <Snap/>
      }
  
      return this.props.children; 
    }
  }

  export default ErrorBoundary;